<iot-platform-ui-loader [display]="loader()"></iot-platform-ui-loader>
